class Filter {
  constructor() {
    if (this.constructor === Filter) {
      throw new TypeError('Can not construct abstract class.');
    }

    window._allergyFilter = [];
  }

  get currentCategoryFilter() {
    return window._categoryFilter || '*';
  }

  get currentAllergyFilter() {
    return window._allergyFilter;
  }

  set currentCategoryFilter(newFilter) {
    if (newFilter === 'all') {
      window._categoryFilter = undefined;
    } else {
      window._categoryFilter = newFilter;
    }
  }

  set currentAllergyFilter(newFilter) {
    window._allergyFilter = newFilter;
  }

  generateFilterSelectorString() {
    let filterRule = this.currentCategoryFilter === '*' ? '*' : `.${this.currentCategoryFilter}`;

    this.currentAllergyFilter.forEach((selector) => {
      filterRule += `:not(.${selector})`;
    });

    return filterRule;
  }
}

export default Filter;
